import { Box, CircularProgress } from '@material-ui/core';
import React from 'react';

export const FullScreenLoaderComponent: React.FC = () => (
    <Box
        zIndex={100}
        display="flex"
        top={0}
        left={0}
        bottom={0}
        right={0}
        bgcolor="rgba(0, 0, 0, 0.1)"
        position="fixed">
        <Box m="auto">
            <CircularProgress />
        </Box>
    </Box>
);
